import { vaultGetRequest } from '../helpers';
import type { IFetchSocialJobsResponse } from './fetch-social-jobs-response';
import { fetchSocialJobsResponseSchema } from './fetch-social-jobs-response';

export async function fetchSocialStatusApi(): Promise<IFetchSocialJobsResponse> {
  return vaultGetRequest({ path: '/social/jobs', schema: fetchSocialJobsResponseSchema });
}
